const pages = [
    {
        title: 'Home',
        href: '/',
        id: 'home-page',
    },
    {
        title: 'About',
        href: '/about',
        id: 'about-page',
    },
    // {
    //     title: 'Technology',
    //     href: '/technology',
    //     id: 'technology-page',
    // },
    // {
    //     title: 'News',
    //     href: '/news',
    //     id: 'news-page',
    // },
];

export default pages;